export default {"src":"/_next/static/media/leave-record-active-icon.4bc6bf91.svg","height":14,"width":14};